import React from "react";
import styled from "styled-components";
import Intro2 from '../videos/videoplayback.mp4'
import media2 from "../videos/media2.mp4"
import media1711 from '../videos/media1711.mp4'

const VideoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px; /* Add spacing between videos */
  padding: 16px; /* Optional padding around the container */
  background-color:lightgray;
`;

const VideoWrapper = styled.div`
  flex: 1 1 45%; /* Adjust width for large screens */
  max-width: 500px; /* Ensure the videos don't grow too large */
  display: flex;
  justify-content: center;

  video { 
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    flex: 1 1 100%; /* Take full width on smaller screens */
  }
`;

const ResponsiveVideos = () => {
  return (
    <VideoContainer>

          <VideoWrapper>
        <video
          src={media1711} // Replace with your second video file URL
          loop
          controls
        />
      </VideoWrapper>
      <VideoWrapper>
        <video
          src={Intro2} // Replace with your first video file URL
          loop
          controls
        />
      </VideoWrapper>
      <VideoWrapper>
        <video
          src={media2} // Replace with your second video file URL
          loop
          controls
        />
      </VideoWrapper>
    
    </VideoContainer>
  );
};

export default ResponsiveVideos;
